import { render, staticRenderFns } from "./DreamListItem.vue?vue&type=template&id=e6ada7d2&scoped=true&"
import script from "./DreamListItem.vue?vue&type=script&lang=ts&"
export * from "./DreamListItem.vue?vue&type=script&lang=ts&"
import style0 from "./DreamListItem.vue?vue&type=style&index=0&id=e6ada7d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ada7d2",
  null
  
)

export default component.exports